import { useEffect, useState } from "react";

//import material
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  Paper,
  CardHeader,
  Typography,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Stack,
  Box,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import axios from "axios";

import config from "../../../../config";

//project components
import CandidateSpecializationForm from "./CandidateSpecializationForm";
import useAxiosAuth from "../../../../hooks/useAxiosAuth";
import { useSelector } from "react-redux";

const CandidateSpecialization = (props) => {
  //Constants
  const axiosAuth = useAxiosAuth();
  const { candidateSpecializations, onSave, candidateId } = props;
  const { userId, profileId, userName, role, displayRole } = useSelector(
    (state) => state.userReducer
  );

  //States
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [selectedCandidateSpecialization, setSelectedCandidateSpecialization] =
    useState({
      id: 0,
      candidateId: candidateId,
      candidateSpecializationMasterId: 0,
      candidateSubSpecializationMasterId: 0,
      specializationName: "",
      subSpecializationName: "",
    });

  const handleAdd = () => {
    setSelectedCandidateSpecialization({
      id: 0,
      candidateId: candidateId,
      candidateSpecializationMasterId: 0,
      candidateSubSpecializationMasterId: 0,
      specializationName: "",
      subSpecializationName: "",
    });
    setOpenAdd(true);
  };
  //Methods
  const handleDelete = () => {
    axiosAuth
      .delete(
        "/api/CandidateSpecializations/" + selectedCandidateSpecialization.id
      )
      .then((response) => {
        onSave();
        setOpenDelete(false);
      })
      .catch((error) => {
        console.log(error);
        setOpenDelete(false);
      });
  };
  const handleSave = () => {
    onSave();
    setOpenAdd(false);
  };
  const handleCancel = () => {
    setOpenAdd(false);
  };
  const handleCancelDelete = () => {
    setOpenDelete(false);
  };

  return (
    <Card elevation={3}>
      <Grid
        sx={{
          background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
          paddingX: 2,
          paddingY: 0.5,
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <Typography
              variant="h6"
              sx={{
                color: "#ffffff",
              }}
            >
              Candidate Specializations
            </Typography>
          </Grid>
          {/* {role !== 4 && ( */}
          <Grid item>
            <IconButton onClick={handleAdd}>
              <AddIcon sx={{ color: "#ffffff" }} />
            </IconButton>
          </Grid>
          {/* )} */}
        </Grid>
      </Grid>
      <Grid item>
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            flexDirection: "column",
          }}
        >
          {candidateSpecializations && candidateSpecializations?.length > 0 ? (
            candidateSpecializations.map((specialization, index) => {
              return (
                <Card
                  key={index}
                  variant="outlined"
                  sx={{
                    margin: 1,
                    paddingX: 1,
                    paddingY: 2,
                    // display: "flex",
                    // justifyContent: "space-between",
                    backgroundColor: "#F5F5F5",
                  }}
                >
                  <Stack spacing={1}>
                    {/* <Typography>
                      <b>Candidate Name:</b> {specialization.candidateName}
                    </Typography> */}

                    <Typography>
                      <b>Specialization:</b> {specialization.specializationName}
                    </Typography>
                    <Typography>
                      <b> Sub Specialization:</b>{" "}
                      {specialization.subSpecializationName}
                    </Typography>
                  </Stack>
                  {role !== 4 && (
                    <>
                      <Divider sx={{ my: 1 }} />
                      <Stack
                        // alignItems="center"
                        // justifyContent="center"
                        // spacing={2}
                        direction="row"
                      >
                        <IconButton
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            setSelectedCandidateSpecialization(specialization);
                            setOpenAdd(true);
                          }}
                        >
                          <EditIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => {
                            setSelectedCandidateSpecialization(specialization);
                            setOpenDelete(true);
                          }}
                        >
                          <DeleteIcon fontSize="inherit" />
                        </IconButton>
                        {/* <Typography>{index + 1}</Typography> */}
                      </Stack>
                    </>
                  )}
                </Card>
              );
            })
          ) : (
            <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
              <Typography variant="body1" color="text.secondary">
                No specialization available
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
          }}
        >
          {candidateSpecializations && candidateSpecializations?.length > 0 ? (
            <TableContainer>
              <Table aria-label="simple table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: 40 }}>#</TableCell>
                    <TableCell align="left" sx={{ width: 180 }}>
                      Specialization
                    </TableCell>
                    <TableCell align="left">Sub Specialization</TableCell>
                    <TableCell align="right" sx={{ width: 90 }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {candidateSpecializations.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell align="left">
                        {row.specializationName}
                      </TableCell>
                      <TableCell align="left">
                        {row.subSpecializationName}
                      </TableCell>
                      <TableCell align="right">
                        {role !== 4 && (
                          <>
                            <IconButton
                              variant="outlined"
                              color="primary"
                              size="small"
                              onClick={() => {
                                setSelectedCandidateSpecialization(row);
                                setOpenAdd(true);
                              }}
                            >
                              <EditIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => {
                                setSelectedCandidateSpecialization(row);
                                setOpenDelete(true);
                              }}
                            >
                              <DeleteIcon fontSize="inherit" />
                            </IconButton>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
              <Typography variant="body1" color="text.secondary">
                No specialization available
              </Typography>
            </Box>
          )}
        </Box>
      </Grid>

      <Dialog open={openAdd} onClose={handleCancel} fullWidth>
        <DialogContent>
          <CandidateSpecializationForm
            onSave={handleSave}
            onCancel={handleCancel}
            selectedCandidateSpecialization={selectedCandidateSpecialization}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={openDelete} onClose={handleCancelDelete} fullWidth>
        <DialogTitle>Delete Specialization</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the specialization{" "}
            <span style={{ color: "#E90000" }}>
              {selectedCandidateSpecialization.specializationName}
            </span>
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} variant="contained">
            Yes
          </Button>
          <Button onClick={handleCancelDelete} variant="outlined">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default CandidateSpecialization;
